import React, { Fragment, useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import DataTable from "react-data-table-component";
import { getCancelledTrips } from "../../../Services/DispatchDashboard.service";
import moment from "moment";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Spinner } from "../../../AbstractElements";
import { Link } from "react-router-dom";
const columns = [
  {
    name: "BOOKING #",
    selector: (row) => row["megaCabsBookingNo"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "DATE & TIME",
    selector: (row) => row["pickUpDateTime"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "NAME",
    selector: (row) => row["name"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "REASON",
    selector: (row) => row["cancelReason"],
    sortable: true,
    center: true,
    // width:"130px",
  },
];

const data = [
  {
    booking_number: "689643875",
    date_time: "Jan 20 11:16:am",
    name: "Ram Kumar"
  },
  {
    booking_number: "689643875",
    date_time: "Jan 20 11:16:am",
    name: "Ram Kumar"
  },
  {
    booking_number: "689643875",
    date_time: "Jan 20 11:16:am",
    name: "Ram Kumar"
  },
  {
    booking_number: "689643875",
    date_time: "Jan 20 11:16:am",
    name: "Ram Kumar"
  },
  {
    booking_number: "689643875",
    date_time: "Jan 20 11:16:am",
    name: "Ram Kumar"
  },
];
const TripCancelationAlertsTable = ({ globalCityField }) => {
  const [tableData, setTableData] = useState([])
  const [loader, setLoader] = useState(false)
  useEffect(() => {
    setLoader(true)
    const serviceCityId = globalCityField.value?.id || null
    const body = {
      serviceCityId
    }
    getCancelledTrips(body).then(result => {
      setLoader(false)
      if (result.data) {
        const processData = result.data.map((element, index) => {
          return {
            megaCabsBookingNo: element.megaCabsBookingNo,
            megaCabsBookingNo: (
              <Link
                to={`${process.env.PUBLIC_URL}/trips/trip-info/${element.id}`}
              >
                {element.megaCabsBookingNo}
              </Link>
            ),
            pickUpDateTime: element.pickUpDateTime
              ? moment(new Date(element.pickUpDateTime)).format("MMM DD HH:mm")
              : "-",
            name: element.custName,
            cancelReason: <>
              <span
                id={"reason" + index}
                style={{
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {element.cancelReason}
              </span>
              <CommonToolTip
                options={{
                  placement: "left",
                  target: "reason" + index,
                }}
              >
                {element.cancelReason}
              </CommonToolTip>
            </>
          }
        })
        const filterData = processData.slice(0, 5)
        setTableData(filterData);
      }

    })
  }, [globalCityField.value]);

  return (
    <Fragment>
      <Card className="trip-cancellation-table">
        <CardHeader>
          <div className="trip-cancellation-title">
            Trip Cancellation Alerts
          </div>
        </CardHeader>
        <CardBody>
          <div className="table-responsive">
            <DataTable
              columns={columns}
              data={tableData}
              center={true}
              fixedHeader
              // customStyles={customStyles}
              progressPending={loader}
              progressComponent={<div className="loader-box" style={{ height: "50vh" }}>
                <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
              </div>}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default TripCancelationAlertsTable;
